module.exports = __webpack_public_path__ + "static/media/csrddc4.15ff2132.svg";